// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__8Eovl","footer":"ModalCreateQualiphyProcedure_footer__3OVZ6","additionData":"ModalCreateQualiphyProcedure_additionData__2E5Ar"};